import React from 'react';
import { Intent } from 'constants/ui';
import BaseHint from '../BaseHint';
const CsvInvalidHint = () => (React.createElement(BaseHint, { intent: Intent.DANGER, multiline: true, text: "Please send a file in the CSV format.", title: "Your file is not in the CSV format" }));
export default CsvInvalidHint;
